import {connect} from 'react-redux';
import {NotesView as Component} from './NotesView';

import {
  //notebookSection,
  incProtocolPage,
  decProtocolPage,
  goProtocolPage,
  setPageInstructions,
  toggleNotesView
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    sectionSelected: state.notebook.protocolSection.scene.sectionSelected,
    currentPage: state.notebook.protocolSection.scene.currentProtocolPage,
    totalPages: state.notebook.protocolSection.scene.totalProtocolPages,
    pageInstructions: state.notebook.protocolSection.scene.currentPageInstructions,
    focusedTask: state.notebook.protocolSection.scene.focusedTask,
    tasks: state.notebook.protocolSection.scene.taskPages,
    level: state.notebook.protocolSection.scene.level,
    notesView: state.notebook.protocolSection.scene.notesView
  };
}

function mapDispatchToProps(dispatch) {
  return {
    // notebookSection: (data) => {
    //   dispatch(notebookSection(data))
    // },
    incProtocolPage: (data) => {
      dispatch(incProtocolPage(data))
    },
    decProtocolPage: (data) => {
      dispatch(decProtocolPage(data))
    },
    goProtocolPage: (data) => {
      dispatch(goProtocolPage(data))
    },
    setPageInstructions: (data) => {
      dispatch(setPageInstructions(data))
    },
    toggleNotesView: (data) => {
      dispatch(toggleNotesView(data))
    }
  };
}

export const NotesView = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
